var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Refresh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.979,7.979l-3.506,3.977l3.071-0.012c0,3.591-2.896,6.603-6.487,6.603c-1.096,0-2.161-0.225-3.061-0.713l-1.208,0.844 c1.222,0.773,2.672,1.231,4.234,1.231c4.393,0,7.951-3.56,7.951-7.953h2.981L18.979,7.979z M5.524,11.943 c0-3.59,2.918-6.507,6.51-6.507c1.096,0,2.139,0.271,3.038,0.759l1.185-0.96c-1.223-0.775-2.673-1.233-4.233-1.233 c-4.393,0-7.952,3.559-7.952,7.953H1.089l3.975,3.975l3.507-3.975L5.524,11.943z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefresh);
export default __webpack_public_path__ + "static/media/ic_refresh.6f1ec255e3ca70d9f28616d158f9b37d.svg";
export { ForwardRef as ReactComponent };